import { onDomReady } from '../utils/dom';
import * as ScrollUtil from '../utils/scrolling';

function scrollToAccordion() {
    const accordions = document.querySelectorAll('.content-accordion .toggler');

    for (const accordion of accordions) {
        accordion.addEventListener('click', function () {
            if (!window.innerWidth < 992 || this.classList.contains('ui-state-active')) {
                return;
            }

            setTimeout(() => {
                ScrollUtil.scrollToTarget(this, -8, 600);
            }, 450);
        });
    }
}

/* handorgel opens its data-open folds delayed (initialOpenTransitionDelay); opening earlier gets undone */
const HANDORGEL_INITIAL_OPEN_DELAY = 200;

/**
 * Opens the accordion fold that contains the URL hash target and scrolls to its header.
 * Anchor = the ID of a child element inside the fold (e.g. "#studien" on an element_group).
 */
function openAccordionFromHash() {
    const hash = window.location.hash;

    if (!hash || hash.length < 2) return;

    let target;

    try {
        target = document.querySelector(decodeURIComponent(hash));
    } catch {
        return;
    }

    const content = target?.closest('.handorgel__content');

    if (!content) return;

    const header = content.previousElementSibling;
    const fold = header?.handorgelFold;

    if (fold) {
        fold.open();
    } else {
        header?.querySelector('button')?.click();
    }

    // handorgel animates the height; scroll when the fold has settled
    setTimeout(() => {
        ScrollUtil.scrollToTarget(header, -8, 600);
    }, 450);
}

onDomReady(() => {
    scrollToAccordion();
});

window.addEventListener('load', () => {
    setTimeout(openAccordionFromHash, HANDORGEL_INITIAL_OPEN_DELAY + 100);
});
window.addEventListener('hashchange', openAccordionFromHash);
